exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".provider .panel {\n  padding: 2rem 1rem; }\n\n.provider .name {\n  font-weight: bold; }\n\n.provider .description {\n  color: #898a8e;\n  margin-bottom: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/providers/show-provider/show-provider.component.scss
// module id = 411
// module chunks = 0